import { apiWithkey } from "../axios";
import { baseApiURL, cepApi } from "../endpoints";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import sleepAwait from "../../utils/sleepAwait";
import findStep from "../../screens/bot/stepModules/findStep";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import sendTag from "../../utils/sendTag";

const fakeLoad = useInitialConfigStore.getState().fakeLoad;

const getCep = async () => {
  setLoadingMessage();

  const { cep } = useUserStore.getState().contrato;
  const url = `${baseApiURL}${cepApi}?cep=${cep}`;
  const storeCepErrorAt = useUserStore.getState().cepErrorAt;

  return apiWithkey
    .get(url)
    .then(async (response) => {
      const address = response.data.data;
      const userCep = useUserStore.getState().contrato.cep;
      const userContratoData = useUserStore.getState().contrato;
      const userBasicData = useUserStore.getState().basic;
      const userLeadData = useUserStore.getState().lead;

      await sleepAwait(fakeLoad);
      removeLoadingMessage();

      if (!address) {
        useBotControlStore.setState({
          currentStep: findStep("cep_nao_encontrado").index,
        });
        return;
      }

      if (address?.cep) {
        useUserStore.setState({
          basic: {
            ...userBasicData,
          },
          lead: {
            ...userLeadData,
          },
          contrato: {
            ...userContratoData,
            bairro: address.bairro,
            cep: address.cep,
            cidade: address.cidade,
            complemento: address.complemento,
            estado: address.estado,
            logradouro: address.logradouro,
            numero: address.numero,
          },
        });
      }

      if (!address.logradouro || !address.bairro) {
        useBotControlStore.setState({
          currentStep: findStep("erro_cep").index,
        });

        return;
      }

      useBotControlStore.setState({
        currentStep:
          storeCepErrorAt === "cep-first-input"
            ? findStep("agradecimento_cep").index
            : findStep("revisao_dados_pessoais").index,
      });

      return response;
    })
    .catch(() => {
      useBotControlStore.setState({
        currentStep: findStep("cep_nao_encontrado").index,
      });
      removeLoadingMessage();
    });
};

export { getCep };
